import { Spin } from 'antd';

// For the loader
const Loader = () => {
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minHeight: '30px',
			}}
		>
			<Spin size="default" />
		</div>
	);
};

export default Loader;
